export default __webpack_public_path__ + "static/media/printer.2b07ec13.svg";